import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MOCK_RESPONSES } from '@app/mock/mock-responses';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class MockHttpInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const mockResponse = this.getMockResponse(request.url);
        if (mockResponse) {
          console.error('ERROR WITH API - using mock data', error);
          return of(mockResponse);
        }
        return throwError(error);
      })
    );

    // COMMENT ABOVE CODE and UNCOMMENT BELOW CODE to USE MOCK DIRECTLY

    // const mockResponse = this.getMockResponse(request.url);
    // if (mockResponse) {
    //     console.log("MOCK DATA")
    //      return of(new HttpResponse(mockResponse));
    // }

    // return next.handle(request);
  }

  private getMockResponse(url: string): any {
    const vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/;
    for (const key of Object.keys(MOCK_RESPONSES)) {
      if (url.includes(key)) {
        if (vinRegex.test(url)) {
          return MOCK_RESPONSES['VIN_LOOKUP'];
        }
        return MOCK_RESPONSES[key];
      }
    }
  }
}
